import { render, staticRenderFns } from "./VirtualReportRow.vue?vue&type=template&id=206d6297"
import script from "./VirtualReportRow.vue?vue&type=script&lang=js"
export * from "./VirtualReportRow.vue?vue&type=script&lang=js"
import style0 from "./VirtualReportRow.vue?vue&type=style&index=0&id=206d6297&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports